import React, { FC, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useHistory } from 'react-router';
import { useUploadingFiles } from '../useFilesUploader';
import { usePrevious } from 'react-use';
import { TagPrefix } from '../../../constants/SystemTags';
import { getItemFromServerResponse } from '../../uploadingFile';
import { MediaManagerSDKFile } from '../../media-manager-sdk';
import { RouteBuilder } from '../../RouteHelpers';
import { MainSource } from '../../../constants/Source';
import { SystemFolderId } from '../../../constants/SystemFolderId';
import { useTrackActions } from '../bi/useTrackActions';
import { ActionName } from '../../../constants/Bi';
import { captureException } from '@sentry/react';

export const AdobeExpressProvider: FC = ({ children }) => {
  const history = useHistory();
  const { uploadedFiles } = useUploadingFiles();
  const prevUploadedFiles = usePrevious(uploadedFiles);
  const { trackActionsDone } = useTrackActions();

  useEffect(() => {
    try {
      const uploadedAdobeFiles = uploadedFiles.filter((file) =>
        file.source?.tags?.some((tag) => tag.startsWith(TagPrefix.AdobeExpressProjectId)),
      );
      const prevUploadedFileIds = (prevUploadedFiles || []).map((file) => file.id);

      const newlyUploadedAdobeFile = uploadedAdobeFiles.find((file) => !prevUploadedFileIds.includes(file.id));
      if (newlyUploadedAdobeFile) {
        const uploadedFileData = getItemFromServerResponse<MediaManagerSDKFile>(newlyUploadedAdobeFile);

        history.push(
          RouteBuilder.Source(
            MainSource.SiteFiles,
            uploadedFileData.folderId || SystemFolderId.SiteFiles,
            uploadedFileData.id,
          ),
        );
        trackActionsDone([uploadedFileData], ActionName.EditInAdobeExpress);
      }
    } catch (e) {
      captureException(e);
    }
  }, [uploadedFiles, prevUploadedFiles, history, trackActionsDone]);

  return (
    <>
      {children}
      {createPortal(
        <div
          id="adobe-express-container"
          style={{
            position: 'absolute',
            zIndex: '9999',
            top: 0,
            width: '100%',
            height: '100%',
          }}
          hidden
        />,
        document.body,
      )}
    </>
  );
};
